module.exports = __webpack_public_path__ + "static/media/temp_7.b22786d4.jpg";